import React, { useState, useRef, useEffect } from "react";
import clsx from "clsx";

import { ReactComponent as IconCaret } from "../../../../assets/svg/caret_up.svg";
import { ReactComponent as IconCheck } from "../../../../assets/svg/check.svg";
import styles from "../ClassDataSurvey.module.scss";
import { IPackage } from "../../../../state";
import useOnClickOutside from "../../../../hooks/useOnClickOutside";

type Props = {
  packages: IPackage[];
  onChange: (material_id: number, package_id: number) => void;
};

const Select: React.FC<Props> = ({ packages, onChange }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<IPackage>();

  useEffect(() => {
    if (packages.length > 0) {
      setSelectedPackage(packages[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packages]);

  useEffect(() => {
    if (selectedPackage) {
      const lastTeachingMaterial =
        selectedPackage.teaching_materials.length - 1;
      onChange(
        selectedPackage.teaching_materials[lastTeachingMaterial].id,
        selectedPackage.id,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPackage?.id]);

  const handleClickOutside = () => setOpen(false);

  useOnClickOutside(ref, handleClickOutside);

  return (
    <div className={styles.wrapSelect} onClick={() => setOpen(!open)} ref={ref}>
      <p>
        {selectedPackage?.name} <IconCaret />
      </p>
      {open && (
        <div className={styles.options}>
          {packages.map(item => {
            const isActive = item.id === selectedPackage?.id;
            return (
              <p
                className={clsx(isActive && styles.active)}
                onClick={() => {
                  setSelectedPackage(item);
                }}
                key={item.id}
              >
                {item.name} {isActive && <IconCheck />}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Select;
